<template>
  <div>
    <Checkbox v-model="handleValue" :disabled="false" checkbox-id="changeLoginPeriod" class="checkboxComponent">
      <span class="label">ログインしたままにする</span>
    </Checkbox>
    <p class="description">共有のパソコンやタブレットではチェックを外してください。</p>
  </div>
</template>

<script>
import Checkbox from '../../../common/common/Checkbox.vue';

export default {
  name: 'CheckboxArea',
  components: {
    Checkbox,
  },
  model: {
    prop: 'checkboxValue',
    event: 'change-checkbox-state',
  },
  props: {
    checkboxValue: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    handleValue: {
      get() {
        return this.checkboxValue;
      },
      set(value) {
        this.$emit('change-checkbox-state', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.checkboxComponent {
  margin-bottom: 4px;
}

.label {
  color: $color-text-primary;
  margin-left: 28px;
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 1.5;
}

.description {
  color: $color-text-secondry;
  font-size: 12px;
  line-height: 1.5;
}
</style>
